import React, { forwardRef, ReactNode } from 'react';
import Sidebar from '../components/layout/Sidebar';
import ToastMessage from '../components/layout/ToastMessage';
import { DecodedIdTokenProvider } from '../contexts/DecodeIdTokenContext';

interface SideLayoutProps {
  children?: ReactNode;
}

const SideLayout = forwardRef<HTMLDivElement, SideLayoutProps>(
  ({ children }, ref) => {
    return (
      <DecodedIdTokenProvider>
        <div ref={ref} className="relative flex h-[100vh] w-[100vw]">
          <ToastMessage></ToastMessage>
          <Sidebar></Sidebar>
          <main className="flex-grow overflow-x-hidden">{children}</main>
        </div>
      </DecodedIdTokenProvider>
    );
  }
);

SideLayout.displayName = 'SideLayout';

export default SideLayout;
